<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col lg="12">
          <b-row class="mb-2">
            <b-col>
              <router-link v-if="item" :to="{ name: 'EXCMCaseShow', params: { id: item.idCase['@id'] } }" class="btn btn-sm btn-default">
                <span v-if="!mobileView">{{$t('buttons.goToCase')}}</span>
                <i v-else class="far fa-arrow-alt-left"></i>
              </router-link>
              <div class="float-right" v-if="ableToViewTasks">
                <router-link :to="{ name: 'EXCMTaskList' }" class="btn btn-sm btn-default">
                  <span v-if="!mobileView">{{$t('buttons.backToTaskList')}}</span>
                  <i v-else class="far fa-arrow-alt-left"></i>
                </router-link>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" lg="8" v-if="item">
          <task-header
            :item="item"
          >
          </task-header>
          <b-row>
            <b-col>
              <p v-if="ableToUpdateTask">
                <b-button variant="info" size="sm" @click="poolOperationTask('return')"  v-if="ableToReturnTask">
                  {{$t('buttons.returnTask')}}
                </b-button>
                <b-button variant="info" size="sm" @click="toggleTransferModal()"  v-if="ableToTransferTask">
                  <span v-if="item.dailyPlanItems.length > 0">{{$t('buttons.transferToAnotherUserDataDailyPlanItem')}}</span>
                  <span v-else>{{$t('buttons.transferToAnotherUserDataTask')}}</span>
                </b-button>
                <b-button variant="info" size="sm" @click="dispatchTask()"  v-if="ableToDispatchTask">
                  {{$t('buttons.dispatchTask')}}
                </b-button>

                <b-btn variant="info" size="sm" v-if="ableToCreateTask && getIdLink(item.idCase.status['@id']) === '1'" @click="addTask()">
                  {{ $t('buttons.finishTaskAndClose') }}
                </b-btn>
              </p>
              <p v-if="(ableToCreateTask || ableToFinishTask) && item.finished === 0 && item.canUpdate">
                <b-button variant="info" size="sm" @click="finishTask(item['@id'])"  v-if="item.idTaskType.idDefaultNextTask">
                  {{ $t('buttons.stopAndAutoCreateNew') }} {{item.idTaskType.idDefaultNextTask.title}}
                </b-button>
                <b-button variant="info" size="sm" @click="finishTask(item['@id'])"  v-else-if="item.idTaskType.taskParams.autoCloseCase">
                  {{ $t('buttons.stopAndClose') }}
                </b-button>
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-btn variant="info" size="sm" @click="createTaskDocument()" v-if="item.finished === 1">
                {{$t('views.excmtask.show.createTaskDocument')}}
              </b-btn>
            </b-col>
          </b-row>
          <b-row v-if="isOwner">
            <b-col>
              <b-btn variant="info" size="sm" @click="showModal('generateDocumentForTaskModal')" v-if="availableDocumentTemplatesToGenerate.length > 0">
                {{$t('views.excmtask.show.generateTaskDocument')}}
              </b-btn>
            </b-col>
          </b-row>
          <b-card v-if="item && (item.idTaskType.taskParams.canHaveDocument || item.documentFiles.length > 0)">
            <b-col>
              <document-files :path="'api/e_x_c_m_tasks/'" :item="item" :fetch-data="() => this.retrieve(decodeURIComponent(this.$route.params.id))"></document-files>
            </b-col>
          </b-card>
          <b-row v-if="documents && documents.length > 0">
            <b-col>
              <b-card>
                <div class="mb-1">
                  <i class="ml-2 fa fa-file-invoice fa-lg"></i><span class="h6 ml-2">{{ $t('views.documents.index') }}</span>
                  <hr class="mb-1 mt-1">
                </div>
                <div>
                  <table class="table table-sm">
                    <thead>
                    <tr>
                      <th>{{$t('views.exsbdocument.list.documentType')}}</th>
                      <th>{{$t('views.exsbdocument.list.number')}}</th>
                      <th>{{$t('views.exsbdocument.list.dateOfIssue')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in documents" :key="item['@id']">
                      <td>
                        <span v-if="item.documentType">
                          {{ item['documentType'].name }}
                        </span>
                      </td>
                      <td>
                        <router-link v-if="ableToViewDocument" :to="{ name: 'EXSBDocumentShow', params: { id: item['@id'] } }">
                          {{ item.number }}
                        </router-link>
                        <span v-else> {{ item.task.idTaskType.title }} </span>
                      </td>
                      <td>
                        {{ $moment(item.dateOfIssue).format('YYYY-MM-DD') }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" lg="4" v-if="item && poolTasks.length > 0">
          <task-timeline
            :item="item"
            :pool-tasks="poolTasks"
          ></task-timeline>
        </b-col>
      </b-row>
      <create-task-modal :id-case="item.idCase['@id']"></create-task-modal>
    </b-col>
    <b-modal id="generateDocumentForTaskModal" ref="generateDocumentForTaskModal" hide-footer>
      <div slot="modal-header" class="w-100">
        <h5 class="modal-title float-left">
          {{$t('global.chooseDocument')}}
        </h5>
        <button type="button" aria-label="Close" class="close" @click="hideModal('generateDocumentForTaskModal')">
          ×
        </button>
      </div>
      <b-row>
        <b-col>
          <model-select required id="idDocumentTemplate" :options="availableDocumentTemplatesToGenerate" v-model="idDocumentTemplate"></model-select>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <b-btn class="btn btn-success" @click="generateDocumentForTask()">{{ $t('buttons.downloadPDF') }}</b-btn>
          <b-btn class="btn btn-danger" @click="hideModal('generateDocumentForTaskModal')">{{ $t('buttons.cancel') }}</b-btn>
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100"></div>
    </b-modal>
    <FinishedTaskDocumentModal @success="retrieve(id)"></FinishedTaskDocumentModal>
    <DispatchTaskModal></DispatchTaskModal>
    <TransferTaskModal :task="item" @success="retrieve(id)"></TransferTaskModal>
    <UpdateTaskParamsModal @reload="retrieve(id)"></UpdateTaskParamsModal>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Progress from 'src/components/UIComponents/Progress'
import getId from '@/utils/getIdFromLink'
import { checkPagePermission, checkPermission, getUserRoles } from '@/utils/checkRoles.js'
import DispatchTaskModal from './components/DispatchTaskModal'
import Loader from '../../Layout/Loader'
import FinishedTaskDocumentModal from '../BusinessBundle/automats/FinishedTaskDocument/FinishedTaskDocumentModal'
import TaskTimeline from './components/TaskTimeline'
import TaskHeader from './components/TaskHeader'
import ApiService from '@/utils/ApiService'
import TransferTaskModal from '@/components/Dashboard/Views/excmtask/modals/TransferTaskModal'
import CreateTaskModal from '@/components/Dashboard/Views/excmtask/modals/CreateTaskModal'
import UpdateTaskParamsModal from '@/components/Dashboard/Views/excmtask/modals/UpdateTaskParamsModal'
import { ModelSelect } from 'vue-search-select'
import DocumentFiles from '@/components/Dashboard/Views/common/DocumentFiles'

export default {
  computed: {
    getUserId () {
      return getUserRoles().id_userdata
    },
    id () {
      return decodeURIComponent(this.$route.params.id)
    },
    ableToViewInvoices () {
      return checkPermission('finances', 'EXSBInvoiceShow')
    },
    ableToViewDocument () {
      return checkPermission('warehouses', 'EXSBDocumentShow')
    },
    ableToViewTasks () {
      return checkPermission('tasks', 'EXCMTaskList')
    },
    ...mapGetters({
      isLoading: 'excmtask/show/isLoading',
      item: 'excmtask/show/retrieved',
      documents: 'excmtask/list/documents',
      isCreateTaskModalVisible: 'excmtask/createModal/isVisible',
      createdTask: 'excmtask/create/created'
    }),
    operation () {
      if (this.item.lastPoolTask.operation === 0) {
        return this.item.lastPoolTask.operation
      }
      return this.item.lastPoolTask.operation || null
    },
    isFinished () {
      return this.item.finished === 1
    },
    isWholesaler () {
      return getUserRoles().roles.includes('ROLE_WHOLESALER')
    },
    isOwner () {
      return getUserRoles().roles.includes('ROLE_OWNER')
    },
    ableToFinishTask () {
      return ((this.item.lastPoolTask && this.item.lastPoolTask.operationTransferUserData &&
          getId(this.item.lastPoolTask.operationTransferUserData['@id']) === this.getUserId) &&
        this.item.started === 1 &&
        this.item.finished === 0
      )
    },
    ableToTakeTask () {
      if (this.isWholesaler) return false
      if (!this.item.canUpdate) return false
      return this.item.lastPoolTask ? !!(!this.isFinished && this.item.lastPoolTask.operation === 0) : false
    },
    ableToCreateTask () {
      return checkPermission('tasks', 'EXCMTaskCreate')
    },
    ableToReturnTask () {
      return !!(!this.isFinished && [1, 2, 3].includes(this.operation))
    },
    ableToDispatchTask () {
      let ableToDispatch = this.checkRoles('tasks', 'EXCMTaskShow', 'dispatchTask')
      return !!(!this.isFinished && ableToDispatch && this.operation === 0)
    },
    ableToTransferTask () {
      return !!(!this.isFinished && [1, 2, 3].includes(this.operation))
    },
    mobileView () {
      return this.$store.state.mobileView
    },
    dispatched: function () {
      return this.$store.state.modals.excmtask.dispatch.dispatched
    },
    ableToUpdateTask: function () {
      if (this.item) {
        if (this.isFinished) return false
        return this.item.canUpdate
      } else return false
    }
  },

  data () {
    return {
      poolTasks: [],
      availableDocumentTemplatesToGenerate: [],
      idDocumentTemplate: null,
      prevRoute: { name: '' },
      autoTakeTaskCompleted: false
    }
  },

  beforeCreate () {
    checkPagePermission('tasks', 'EXCMTaskShow')
  },

  components: {
    DocumentFiles,
    UpdateTaskParamsModal,
    CreateTaskModal,
    [Progress.name]: Progress,
    DispatchTaskModal,
    Loader,
    FinishedTaskDocumentModal,
    TaskTimeline,
    TaskHeader,
    TransferTaskModal,
    ModelSelect
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(this.id)
    this.fetchDocuments({ task: getId(this.$route.params.id) })
  },

  watch: {
    item: function (val) {
      if (val) {
        this.getPoolTask(this.$route.params.id)
        this.handleAutoTakeTaskAfterEnter()
        this.fetchAvailableDocumentTemplatesToGenerate()
      }
    },
    dispatched: function (val) {
      if (val === 1) {
        this.$store.state.modals.excmtask.dispatch.dispatched = 0
        this.retrieve(this.id)
      }
    },
    isCreateTaskModalVisible (val) {
      if (!val && this.createdTask) {
        this.retrieve(this.id)
        this.resetCreatedTask()
      }
    }
  },

  methods: {
    ...mapMutations({
      toggleTransferModal: 'excmtask/transferModal/toggleModal',
      toggleCreateTaskModal: 'excmtask/createModal/toggleModal'
    }),
    ...mapActions({
      reset: 'excmtask/show/reset',
      retrieve: 'excmtask/show/retrieve',
      fetchDocuments: 'excmtask/list/fetchDocuments',
      resetCreatedTask: 'excmtask/create/reset'
    }),

    createTaskDocument () {
      this.$store.state.modals.finishedtaskdocument.create.show = 1
      this.$store.state.modals.finishedtaskdocument.create.task = this.item
    },

    dispatchTask () {
      this.$store.state.modals.excmtask.dispatch.show = 1
      this.$store.state.modals.excmtask.dispatch.taskIRI = this.item['@id']
    },

    copyObject (object) {
      return JSON.parse(JSON.stringify(object))
    },

    handlePoolTaskResponse (response) {
      let taskCreate = this.buildPoolTask('create')
      this.poolTasks = this.copyObject(this.item.dailyPlanItems)
      for (let i in this.poolTasks) {
        this.poolTasks[i].objectType = 'dailyPlanItem'
        this.poolTasks[i].createdAt = this.$moment(this.poolTasks[i].createdAt).add(1, 'second')
      }
      let data = response.items
      for (let d in data) {
        data[d].objectType = 'poolTask'
        this.poolTasks.push(data[d])
      }
      this.poolTasks.sort(function (a, b) {
        return new Date(a.createdAt) - new Date(b.createdAt)
      })
      this.poolTasks.unshift(taskCreate)
      if (this.item.finishDate !== null) {
        let taskClose = this.buildPoolTask('close')
        this.poolTasks.push(taskClose)
      }
    },

    buildPoolTask (type) {
      if (type === 'create') {
        return {
          createdAt: this.item.createdAt,
          operationDate: this.item.createdAt,
          operation: -1,
          operationTransferUserData: null,
          operationUserData: null,
          objectType: 'poolTask'
        }
      } else if (type === 'close') {
        return {
          createdAt: this.item.finishDate,
          operationDate: this.item.finishDate,
          operation: -2,
          operationTransferUserData: null,
          operationUserData: null,
          objectType: 'poolTask'
        }
      }
    },

    async getPoolTask (id) {
      this.poolTasks = []
      const response = await new ApiService(`e_x_c_m_tasks/${getId(id)}/pool_tasks`).getResults()
      if (response) this.handlePoolTaskResponse(response)
    },

    archiveItem (item) {
      this.$Swal({
        title: this.$t('notifications.archiveTitle') + ' ' + this.$t('notifications.archiveDescription'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.$http
            .put('api/e_x_c_m_tasks/' + this.getIdLink(this.item['@id']), {
              state: 0
            })
            .then(response => {
              this.$router.push({ name: 'EXCMTaskList' })
              this.$Swal({ // show notification with success
                type: 'success',
                title: this.$t('notifications.update.updatedTitle'),
                showConfirmButton: false,
                timer: 2500
              })
            })
            .catch(error => {
              if (error.response.status === 400) {
                let text = ''
                for (let i in error.response.data) {
                  text += error.response.data[i] + '\n'
                }
                this.$Swal({
                  type: 'warning',
                  title: text,
                  timer: 2500
                })
              }
              console.log(error)
            })
        }
      })
    },

    async poolOperationTask (operation) {
      let id = getId(this.$route.params.id)
      await new ApiService(`e_x_c_m_tasks/${id}/${operation}`).put({})
      await this.retrieve(this.$route.params.id)
    },

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXCMTaskList' }))
      }
    },
    addTask () {
      this.toggleCreateTaskModal()
    },
    async finishTask (iri) {
      let id = getId(iri)
      await new ApiService(`e_x_c_m_tasks/${id}/finish`).put({})
      this.retrieve(decodeURIComponent(this.$route.params.id))
    },
    async handleAutoTakeTaskAfterEnter () {
      if (!this.autoTakeTaskCompleted && this.ableToTakeTask && this.$store.getters['configuration/autoTakeTaskAfterEnter']) {
        this.autoTakeTaskCompleted = true
        const decision = await this.$Swal({
          title: this.$t('notifications.excmtask.takeTaskAutomatically'),
          type: 'question',
          showConfirmButton: true,
          confirmButtonText: this.$t('buttons.yes'),
          showCancelButton: true,
          cancelButtonText: this.$t('buttons.no')
        })
        if (decision) {
          const response = await new ApiService(`e_x_c_m_tasks/${getId(this.item['id'])}/take`).put({})
          if (response.status === 200) {
            this.retrieve(this.id)
          }
        }
      }
    },
    async fetchAvailableDocumentTemplatesToGenerate () {
      this.availableDocumentTemplatesToGenerate = []
      if (this.item.idTaskType['@id']) {
        let params = { idTaskType: this.item.idTaskType['@id'], templateType: 3 }
        const response = await new ApiService('document_templates', params).getResults()
        this.availableDocumentTemplatesToGenerate = response.items.map(entry => {
          return { value: entry['@id'], text: entry.title }
        })
      }
    },
    generateDocumentForTask () {
      let params = { idDocumentTemplate: getId(this.idDocumentTemplate) }
      new ApiService(this.item['@id'] + '/generate_document', params).downloadFile('task.pdf' + ' ' + this.$moment().format('YYYY-MM-DD'))
    },
    getIdLink (link) {
      return getId(link)
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    },
    showModal (modal) {
      this.$refs[modal].show()
    },
    hideModal (modal) {
      this.$refs[modal].hide()
    }
  }
}
</script>
